import VueKeycloak from './vue-keycloak.js'

const KeycloakStub = {
  install: function (Vue) {
    const userId = (window.location.search.match(/[?&]userId=([^&$]+)/) || [])[1] || 'user'
    Vue.prototype.$keycloak = {
      authenticated: true,
      logout () { },
      ready: true,
      subject: userId,
      user: {
        email: userId,
        username: userId
      }
    }
  }
}

const Keycloak = {
  install: function (Vue) {
    if (Vue.prototype.$env.KEYCLOAK_URL) {
      Vue.use(VueKeycloak, {
        keycloakOptions: {
          'clientId': Vue.prototype.$env.KEYCLOAK_CLIENT,
          'realm': Vue.prototype.$env.KEYCLOAK_REALM,
          'url': Vue.prototype.$env.KEYCLOAK_URL,
          'ssl-required': 'external',
          'resource': Vue.prototype.$env.KEYCLOAK_CLIENT,
          'public-client': true
        },
        keycloakInitOptions: {
          checkLoginIframe: false,
          onLoad: Vue.prototype.$env.MANAGER_URL ? 'check-sso' : 'login-required'
        }
      })
    } else {
      Vue.use(KeycloakStub)
    }
  }
}

export default Keycloak



// WEBPACK FOOTER //
// ./src/plugins/keycloak.js